<script>
export default {
  computed: {
    cards() {
      return this.$store.getters["getTeams"];
    },
  },
  mounted() {
    this.$store.dispatch("fetchTeams");
  },
};
</script>
<template>
  <section class="section doctor" aria-label="doctor">
    <div class="container">
      <p class="section-subtitle text-center">Our Doctor</p>

      <h2 class="h2 section-title text-center">Best Expert Dentist</h2>

      <ul class="has-scrollbar">
        <li class="scrollbar-item" v-for="(card, index) in cards" :key="index">
          <div class="doctor-card">
            <div
              class="card-banner img-holder"
              style="--width: 460; --height: 500"
            >
              <img
                :src="card.image"
                width="460"
                height="500"
                loading="lazy"
                :alt="card.image"
                class="img-cover"
              />
            </div>

            <h3 class="h3">
              <a href="#" class="card-title">{{ card.name }}</a>
            </h3>

            <p class="card-subtitle">Dentist</p>

            <ul class="card-social-list">
              <li>
                <a href="#" class="card-social-link">
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
              </li>

              <li>
                <a href="#" class="card-social-link">
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
              </li>

              <li>
                <a href="#" class="card-social-link">
                  <ion-icon name="logo-instagram"></ion-icon>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
